<template>
  <div class="linkListFilterPanel">
    <div class="commandDeck">
      <div class="commandDeck__zone commandDeck__zone--filters">
        <div class="filterDeckHeader">
          <div class="filterDeckHeader__leading">
            <span class="zoneHeader__title">筛选条件</span>
            <div v-if="activeFilterCount" class="filterChips">
              <span class="filterChip">已筛选 {{ activeFilterCount }} 项</span>
              <button
                type="button"
                class="filterChip filterChip--clear"
                @click="$emit('reset-and-search')"
              >
                清除
              </button>
            </div>
          </div>
          <div class="actionBar">
            <el-button
              class="actionButton actionButtonQuery"
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="$emit('search')"
            >
              查询
            </el-button>
            <el-button
              class="actionButton actionButtonOutline"
              size="small"
              icon="el-icon-plus"
              v-check-role
              @click="$emit('go-create')"
            >
              新增 iOS App
            </el-button>
            <el-button
              class="actionButton actionButtonGhost"
              size="small"
              icon="el-icon-upload2"
              :loading="zipLoading"
              @click="$emit('upload-zip')"
            >
              上传 zip
            </el-button>
            <el-button
              class="actionButton actionButtonGhost actionButton--reset"
              size="small"
              icon="el-icon-refresh-left"
              @click="$emit('reset-filters')"
            >
              重置
            </el-button>
          </div>
        </div>
        <div class="filterGrid filterGrid--two">
          <div class="filterItem">
            <span class="searchText">title</span>
            <el-input
              class="filterControl"
              placeholder="请输入 title"
              prefix-icon="el-icon-search"
              :value="title"
              size="small"
              clearable
              @input="$emit('update:title', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem">
            <span class="searchText">target</span>
            <el-input
              class="filterControl"
              placeholder="请输入 target"
              prefix-icon="el-icon-search"
              :value="target"
              size="small"
              clearable
              @input="$emit('update:target', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem filterItem--wide">
            <span class="searchText">comment</span>
            <el-input
              class="filterControl"
              placeholder="请输入 comment"
              prefix-icon="el-icon-search"
              :value="comment"
              size="small"
              clearable
              @input="$emit('update:comment', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="showPanelSummary" class="filterPanelSummary">
      <span class="filterPanelSummary__label">共</span>
      <strong class="filterPanelSummary__count">{{ panelTotalCount }}</strong>
      <span class="filterPanelSummary__label">条</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IosAppInfoListFilterPanel',
  props: {
    title: { type: String, default: '' },
    target: { type: String, default: '' },
    comment: { type: String, default: '' },
    zipLoading: { type: Boolean, default: false },
    activeFilterCount: { type: Number, default: 0 },
    panelTotalCount: { type: Number, default: 0 },
    showPanelSummary: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
@import '../../resourceManage/genericResourceManage/linkListTheme.css';
@import '../../resourceManage/genericResourceManage/linkActionButtons.css';
@import '../../resourceManage/genericResourceManage/linkListFilterPanel.css';
</style>